module.exports = __webpack_public_path__ + "img/person.a2bf5a21.svg";